import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import LoadingScreen from '../../../components/LoadingScreen';
import { api } from '../../../hooks/api.hooks';
import { useAuthentication } from '../../../state/Authentication';

const EmailVerify: React.FC = () => {
  const { search } = useLocation();
  const params = React.useMemo(() => new URLSearchParams(search), [search]);
  const history = useHistory();
  const {
    state: { user },
  } = useAuthentication();
  const redirectPage = React.useMemo(() => (user.emailPrimary ? 'wijzigen' : 'toevoegen'), []);

  React.useEffect(() => {
    const activate = async () => {
      try {
        await api.post('/access-keys/email/verify', {
          code: params.get('code'),
          userId: params.get('user_id'),
        });
        history.push(`/gegevens/aanmeldsleutels/e-mail/${redirectPage}/gekoppeld`);
      } catch (e) {
        history.push(`/gegevens/aanmeldsleutels/e-mail/${redirectPage}/ongeldig`);
      }
    };

    activate();
  }, [params]);

  return <LoadingScreen />;
};

export default EmailVerify;
